<template>
	<component
		:is="tag"
		:to="to"
		:target="target"
		@click="click"
		class="c-button"
		:style="`background: #${bg}; color: #${color}`"
		:class="[{ 'c-button--disabled': disabled }]">
		<slot/>
	</component>
</template>

<script>
export default {
	name: 'c-button',
	props: {
		tag: {
			type: String,
			default: 'router-link',
		},
		to: {
			type: [String, Object],
			default: '',
		},
		target: {
			type: String,
			default: '_self',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		bg: {
			type: String,
			default: '7289DA',
		},
		color: {
			type: String,
			default: 'fff',
		},
	},
	methods: {
		click() {
			this.$emit('click');
		},
	},
};
</script>

<style lang="scss">
	.c-button {
		display: inline-flex;
		align-items: center;
		padding: 20px 60px 15px;
		text-decoration: none;
		text-align: center;
		font-size: 14px;
		line-height: 14px;
		font-weight: 700;
		text-transform: uppercase;
		justify-content: center;
		outline: none;
		width: auto;
		border: none;
		box-shadow: unset;
		clip-path: polygon(0 0, 97% 15%, 100% 100%, 0% 100%);
		&--disabled{
			pointer-events: none;
			opacity: .4;
		}

		&:hover {
			cursor: pointer;
		}

		&:active,
		&:focus {
			outline: none;
			box-shadow: unset;
		}
	}
</style>
